export default {
  methods: {
    getColorRandom(length) {  //随机生成颜色
      let colorAll = []
      let color12 = [
        '#0BB78E', '#4CD177', '#A2CC53', '#F46950', '#FF9800',
        '#FFC107', '#FEEA38', '#589FFD', '#89BBFD', '#DB89ED',
        '#9F7CF4', '#7D8AF6']
      let color20 = [
        '#B4D4FE', '#FDB128', '#89BBFD', '#FF9600', '#589FFD', '#F46950',
        '#1FB4D2', '#FB3A37', '#1DAC91', '#EF6392', '#53CE7B', '#ED51C9', 
        '#A2CC53', '#DB89ED', '#B8ED28', '#9F7CF4', '#FEEA38', '#7D8AF6', 
        '#FDD528', '#4B73D3']
      let color60 = [
        '#B4D4FE', '#FDB128', '#89BBFD', '#FF9600', '#589FFD', '#F46950', 
        '#1FB4D2', '#FB3A37', '#1DAC91', '#EF6392', '#53CE7B', '#ED51C9', 
        '#A2CC53', '#DB89ED', '#B8ED28', '#9F7CF4', '#FEEA38', '#7D8AF6', 
        '#FDD528', '#4B73D3', '#658CBB', '#4D8D78', '#74ACF2', '#94E2C8', 
        '#BCD7FA', '#4CAF50', '#A7F2FF', '#CCF1E4', '#DDFFFF', '#64E7F7', 
        '#B49FCF', '#5EEAD4', '#D1BAD3', '#FDA4AF', '#E2E5F5', '#FBCFE8', 
        '#CFACAC', '#C6A8F5', '#FCEEEE', '#F1E8FF', '#B0B187', '#ECCE00', 
        '#93BFAC', '#FFF301', '#8CA1A8', '#DCFF01', '#BAD3BB', '#9DDC00', 
        '#D3C7BA', '#B6F0B8', '#BFC9E3', '#ECFBCB', '#FFE4B0', '#FF9C70', 
        '#FFDADA', '#FFCAAF', '#CCEAEF', '#FFCF70', '#E8FBFE', '#FFF1D6', ]
        colorAll = length<=12 ? color12 : length>13 || length<=20 ? color20 : length>20 ? color60 : []
      // let color = '';
      // let r = Math.floor(Math.random() * 256);
      // let g = Math.floor(Math.random() * 256);
      // let b = Math.floor(Math.random() * 256);
      // color = `rgb(${r},${g},${b})`;
      // return color;
      return colorAll
      // return '#'+Math.floor(Math.random()*0xffffff).toString(16);
    },
   async render_left(data) {
    //颜色总数
    let colorLength = data.categorySaleList ? data.categorySaleList.map(v=>v.mouth).length : 0
    let colorArr = this.getColorRandom(colorLength)
    console.log(colorLength);
    console.log(colorArr);
    // for(let i=0; i<colorLength; i++) {
    //   colorArr.push(this.getColorRandom()[i])
    // }
     let series = []
     if(data.categorySaleList) {
      await data.categorySaleList.forEach((v,index)=>{
        series.push({
            name: v.mouth,
            type: 'bar',
            barMinHeight: .5,
            data: v.tips.map(v=>v.proCount),
            emphasis: {
              focus: 'series'
            },
            // barWidth:20,
            stack: 'Ad'
        })
        console.log(series);
        // v.monthProCountList
      })
     }
      let option = {
        // color:['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#fc8488', '#6cc5b9', '#8a9bbb'],
        color: colorArr,
        // title: {
        //   text: '今年销售产品上新概览',
        //   top: 10
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          confine: true
        },
        legend: {
          top: 45,
          data: data.categorySaleList ? data.categorySaleList.map(v=>v.mouth).slice(0,12) : [],
          textStyle: {
            color: '#fff',
            fontFamily: 'PingFangSC'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: 120,
          containLabel: true
        },
        // dataZoom: {
        //   type: 'inside',
        //   start: 0,
        //   end: data.allCategoryName.length<20 ? 100 : 24
        // },
        xAxis: [
          {
            type: 'category',
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            data: data.allCategoryName ? data.allCategoryName.slice(0,12) : [],
            axisLabel: {
              color: 'rgba(255,255,255,0.9)',
              interval: 0,
              rotate: 45
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#e2e2e2',
                opacity: 0.5,
                width: 0,
                fontFamily: 'PingFangSC',
              }
            },
            splitLine: {
              show: true,
              interval: 'auto',
              lineStyle: {
                type: 'dashed',//虚线
                color: '#fff',
                width: 1,
                opacity: 0.3,
                dashOffset: 20
              },
            },
          }
        ],
        series: series.slice(0,12)
      };
      let $instance = this.$echarts.init(this.$refs['overview']);
      $instance.setOption(option,true);
      $instance.on('click',params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog(colorArr)
    });
    }
  }
}